// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"9a70268a","194":"473dfdb1","822":"6ac46531"}[chunkId] + ".chunk.css";
};